import { render, staticRenderFns } from "./DataRenderer.vue?vue&type=template&id=2f39e074&scoped=true"
import script from "./DataRenderer.vue?vue&type=script&lang=js"
export * from "./DataRenderer.vue?vue&type=script&lang=js"
import style0 from "./DataRenderer.vue?vue&type=style&index=0&id=2f39e074&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f39e074",
  null
  
)

export default component.exports